import React from 'react';
import { Sparkles, CheckCircle, TrendingUp, Users, Award, ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Badge } from '../../components/ui/badge';

const SkinCam = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B1220]">
      <div className="relative bg-gradient-to-r from-[#D946EF]/20 via-[#0B1220] to-[#7C3AED]/20 border-b border-[#1F2A3A] pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-xl bg-[#D946EF]/20 flex items-center justify-center">
              <Sparkles size={32} className="text-[#D946EF]" />
            </div>
            <div>
              <Badge className="bg-[#D946EF]/20 text-[#D946EF] border-[#D946EF]/30 mb-2">In R&D</Badge>
              <h1 className="text-5xl md:text-6xl font-bold text-white">Yamai SkinCam</h1>
            </div>
          </div>
          <p className="text-[#8A90A0] text-xl max-w-3xl">Compact AI Camera for Dermatological Analysis</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-white mb-6">Overview</h2>
          <div className="bg-[#1F2A3A]/30 backdrop-blur-sm rounded-2xl p-8 border border-[#1F2A3A]">
            <p className="text-[#E6E8EF] text-lg leading-relaxed mb-4">
              Yamai SkinCam is a small smart camera that captures high-resolution images of skin spots, moles, pigmentation, and rashes. It uses AI algorithms to analyze images and determine medical risk levels.
            </p>
            <p className="text-[#8A90A0] leading-relaxed">
              With AI-powered detection of skin cancer risk, eczema, psoriasis, and fungal infections, SkinCam enables early detection of skin conditions at home or in clinical settings.
            </p>
          </div>
        </section>

        <section className="bg-gradient-to-r from-[#D946EF]/10 to-[#7C3AED]/10 backdrop-blur-sm rounded-2xl p-8 border border-[#D946EF]/30">
          <h2 className="text-2xl font-bold text-white mb-4">Get Involved</h2>
          <p className="text-[#8A90A0] mb-6">Interested in partnering, investing, or collaborating on this project?</p>
          <div className="flex flex-wrap gap-4">
            <Button onClick={() => navigate('/contact')} className="bg-[#D946EF] hover:bg-[#D946EF]/80 text-white">
              Contact Us <ArrowRight size={20} className="ml-2" />
            </Button>
            <Button onClick={() => navigate('/projects')} variant="outline" className="border-[#8A90A0]/30 text-white hover:bg-[#1F2A3A]/50">
              Back to Projects
            </Button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SkinCam;
